import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7bcd06b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-stretch h-100" }
const _hoisted_2 = {
  key: 2,
  class: "h-100 w-100 d-flex flex-column align-items-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-auto d-flex flex-column align-items-center" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "big-logo",
    src: "favicon.svg",
    alt: "Eighty Days Logo"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "mt-2" }, "Eighty Days"),
  /*#__PURE__*/_createElementVNode("div", { class: "subtitle faded" }, "Please Log In")
], -1))
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_hud = _resolveComponent("hud")!
  const _component_open_layers_map = _resolveComponent("open-layers-map")!
  const _component_user_management = _resolveComponent("user-management")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.haveUser)
      ? (_openBlock(), _createBlock(_component_hud, { key: 0 }))
      : _createCommentVNode("", true),
    (_ctx.haveUser)
      ? (_openBlock(), _createBlock(_component_open_layers_map, { key: 1 }))
      : _createCommentVNode("", true),
    (!_ctx.haveUser)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createVNode(_component_user_management, { class: "user-manager-bubble" })
  ]))
}